import { Th, type StackProps } from '@chakra-ui/react';

export type UiThProps = StackProps;

export const UiTh = Th;
